const getBaseName = (assetPathOrURL /*:: :string */) =>
    assetPathOrURL.split("#")[0].split("?")[0].split("/").pop();

/**
 * Given an asset path or URL isolate the basename and remove the chunk hash and cache-bust integer.
 *
 * IMPORTANT
 *  - this algorithm must exactly match the webpack output filename format in webpack.config.js
 *  - this code must be nodejs compatible as it is also used in the webpack.config.js
 */
const sanitiseAssetName =
    (isDevelopment /*:: :boolean */) /*:: :(string => string) */ =>
    (assetPathOrURL /*:: :string */) => {
        const baseName = getBaseName(assetPathOrURL);

        // we desire "[name.with.dots].[ext]"
        // in debug we expect "[name.with.dots].[ext]"
        // in production we expect "[name.with.dots].[hash].[cache-bust].[ext]"
        const split = baseName.split(".");

        // CHANGED: Need to add to process.env.BUNDLER
        const BUNDLER = "parcel";
        if (BUNDLER === "parcel") {
            if (split.length === 1) {
                // Inline bundles are only an id
                return split[0];
            }
            // return the first part and extension - this should always be valid for Parcel bundles.
            // In the case of shared bundles (e.g. shared.hash.js) this will return 'shared.js'.
            // This will cause only the first shared bundle loaded to be tracked.
            // In the short term this is desired to prevent too much noise.
            return [split[0], split[split.length - 1]].join(".");
        }

        if (isDevelopment || split.length < 2) {
            return baseName;
        }
        // CHANGED
        const file = split.slice(0, 1);
        const extension = split.slice(-1);
        return `${file}.${extension}`;
    };

module.exports = {
    sanitiseAssetName
};
